import * as modal from "./modal.ts";
import TPL from '../filer/modal_progress.mustache'

export function newMultiBar(fileCount){
  var 
    data = {rate:0,partialRate:0},
    i = 0,
    theModal = modal.openModal(TPL,{}),
    mainRateNode = theModal.find('.pgbar-panel-rate'),
    subRateNode = theModal.find('.pgbar-panel-partialrate'),
    mainRateTextNode = theModal.find('.pgbar-panel-rate-text');

  function maj(){
    mainRateNode.css('stroke-dashoffset',100-100*data.rate)
    if(data.partialRate===0){
      subRateNode.css('transition','unset')
    }else{
      subRateNode.css('transition','all ease 0.5s')
    }
    subRateNode.css('stroke-dashoffset',100-100*data.partialRate)
    
    mainRateTextNode.html((100*data.rate).toFixed(1)+'%')
    
  }  
  return {
    subProgress(){
      return {
        progress(rate){
          data.partialRate = rate;
          data.rate = (i+rate)/fileCount
          maj();
        },
        close(){
          data.rate = (i)/fileCount;
          data.partialRate = 0;
          i++;
          maj();
        }
      }
    },
    close(){
      modal.closeModal(theModal)
    }
    
  }
}
export function newMultiBarSimple(todoCount){
  var 
    data = new Array(todoCount),
    i = 0,
    theModal = modal.openModal(TPL,{}),
    mainRateNode = theModal.find('.pgbar-panel-rate'),
    mainRateTextNode = theModal.find('.pgbar-panel-rate-text');

  data.fill(0);
  function getRate(){
    return data.reduce((prev,current)=>prev+current,0)/todoCount;
  }
  function maj(){
    var rate = getRate()
    mainRateNode.css('stroke-dashoffset',100-100*rate)
    mainRateTextNode.html((100*rate).toFixed(1)+'%')
  }  
  return {
    subProgress(){
      var idx = i;
      i++;
      return {
        progress(rate){
          data[idx] = rate;
          maj();
        },
        close(){
          data[idx] = 1;
          maj();
        }
      }
    },
    close(){
      modal.closeModal(theModal)
    }
  }
}